import React, { Component } from 'react';
import SideMenuOcean from '../../components/SideMenuOcean/SideMenuOcean';
import OceanBg from '../../components/OceanBg/OceanBg';
import styled from 'styled-components';
import InfoAquaticlife from '../../components/InfoAquaticlife/InfoAquaticlife';
import InfoLionfish from '../../components/InfoLionfish/InfoLionfish';
import InfoLanternfish from '../../components/InfoLanternfish/InfoLanternfish';
import InfoCoral from '../../components/InfoCoral/InfoCoral';
import InfoSeaturtle from '../../components/InfoSeaturtle/InfoSeaturtle';
import InfoPhytoplankton from '../../components/InfoPhytoplankton/InfoPhytoplankton';
import InfoZooplankton from '../../components/InfoZooplankton/InfoZooplankton';
import InfoAlbacore from '../../components/InfoAlbacore/InfoAlbacore';
import InfoJuvenile from '../../components/InfoJuvenile/InfoJuvenile';
import InfoShark from '../../components/InfoShark/InfoShark';
import InfoKrill from '../../components/InfoKrill/InfoKrill';
import InfoUrchin from '../../components/InfoUrchin/InfoUrchin';
import InfoKelp from '../../components/InfoKelp/InfoKelp';
import InfoFlatworm from '../../components/InfoFlatworm/InfoFlatworm';
import InfoCrab from '../../components/InfoCrab/InfoCrab';
import InfoClam from '../../components/InfoClam/InfoClam';
import InfoSeagrass from '../../components/InfoSeagrass/InfoSeagrass';
import InfoJellyfish from '../../components/InfoJellyfish/InfoJellyfish';
import {Link} from 'react-router-dom';
import back from '../../assets/back.png';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;
const Navlink = styled(Link)`

    text-decoration:none;
    color:#ffffff;
  
`;


const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
  margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;


const Backico = styled.img`
  margin-left:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:20px;
  height:auto;
  margin-right:5px;
`;

class Ocean_Aquaticlife extends Component{

  render(){

    return(
      
        <body> 

          <SideMenuOcean />
          <OceanBg/>

         
         <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree><Link to="/Oceans"><Backico src= {back}/></Link><Navlink to="/Oceans">Oceans</Navlink>/ Aquatic Life</Tree>   
          </Contentwrapper>        
              <InfoAquaticlife/>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
              <Impactwrapper><Link to="/Oceans_Phytoplankton"><InfoPhytoplankton/></Link></Impactwrapper>  
              <Impactwrapper><Link to="/Oceans_Sharks"><InfoShark/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Crabs"><InfoCrab/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Lionfish"><InfoLionfish/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Zooplankton"><InfoZooplankton/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Jellyfish"><InfoJellyfish/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Urchins"><InfoUrchin/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Seagrass"><InfoSeagrass/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Bivalves"><InfoClam/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Lanternfish"><InfoLanternfish/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Krill"><InfoKrill/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Kelp"><InfoKelp/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Juvenile"><InfoJuvenile/></Link></Impactwrapper>
              <Impactwrapper><Link to="/Oceans_Coral-reefs"><InfoCoral/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Flatworm"><InfoFlatworm/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Sea-turtle"><InfoSeaturtle/></Link></Impactwrapper> 
              <Impactwrapper><Link to="/Oceans_Albacore"><InfoAlbacore/></Link></Impactwrapper> 
           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>

        </body>
      
      );

  } 
}

export default Ocean_Aquaticlife;
